/**
 * The three order-safety limits shared by firm defaults and every
 * override rule scope (symbol / provider / account). `null` = not
 * configured (an override inherits from the firm defaults).
 */
export interface RiskLimits {
    readonly maxPrice: number | null;
    readonly maxSize: number | null;
    readonly maxOrderTotal: number | null;
}

export type RiskLimitField = keyof RiskLimits;

export const RISK_LIMIT_FIELDS: readonly RiskLimitField[] = ['maxPrice', 'maxSize', 'maxOrderTotal'];

export const EMPTY_RISK_LIMITS: RiskLimits = { maxPrice: null, maxSize: null, maxOrderTotal: null };

export function formatRiskLimitValue(value: number | null): string {
    return value === null ? '' : value.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

export function riskLimitsEqual(a: RiskLimits, b: RiskLimits): boolean {
    return RISK_LIMIT_FIELDS.every((field) => a[field] === b[field]);
}
